import { useSelector } from "react-redux";
import { RootState } from "../../types/typesOfState";

function SvgAnimation() {
  const { theme } = useSelector((state: RootState) => state.themeReducer);
  let appTheme = "";
  if (theme === "other") {
    appTheme = "darktheme__svg-container";
  }
  return (
    <div className={`intro__content__svg-container ${appTheme}`} id="svgcont">
      <svg
        width="803"
        height="775"
        viewBox="0 0 803 728"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="undraw_web_developer">
          <g id="flower">
            <path
              id="flower-pink"
              d="M446.604 370.774C651.778 476.658 737.5 712.5 737.5 712.5C737.5 712.5 501.57 766.07 296.397 660.186C91.2233 554.302 0 323.76 0 323.76C0 323.76 241.43 264.889 446.604 370.774Z"
              fill="url(#paint0_linear_1_2)"
            />
            <path
              id="flower-yellow"
              d="M377.488 444.037C500.005 641.003 737.984 713.613 737.984 713.613C737.984 713.613 777.323 466.876 654.806 269.909C532.288 72.9423 294.309 0.333344 294.309 0.333344C294.309 0.333344 254.97 247.071 377.488 444.037Z"
              fill="url(#paint1_linear_1_2)"
            />
          </g>
          <g id="web-window">
            <path
              id="Rectangle 62"
              d="M802.114 129.711H338.473V349.717H802.114V129.711Z"
              fill="#BDBDBD"
            />
            <path
              id="Rectangle 80"
              d="M801.917 117H338.276V136.697H801.917V117Z"
              fill="#8D8080"
            />
            <path
              id="Ellipse 90"
              d="M352.913 132.233C354.929 132.233 356.564 130.598 356.564 128.582C356.564 126.566 354.929 124.931 352.913 124.931C350.897 124.931 349.262 126.566 349.262 128.582C349.262 130.598 350.897 132.233 352.913 132.233Z"
              fill="white"
            />
            <path
              id="Ellipse 91"
              d="M366.77 132.233C368.786 132.233 370.421 130.598 370.421 128.582C370.421 126.566 368.786 124.931 366.77 124.931C364.754 124.931 363.119 126.566 363.119 128.582C363.119 130.598 364.754 132.233 366.77 132.233Z"
              fill="white"
            />
            <path
              id="Ellipse 92"
              d="M380.627 132.233C382.644 132.233 384.278 130.598 384.278 128.582C384.278 126.566 382.644 124.931 380.627 124.931C378.611 124.931 376.977 126.566 376.977 128.582C376.977 130.598 378.611 132.233 380.627 132.233Z"
              fill="white"
            />
            <path
              id="web-background"
              d="M788.857 148.577H351.731V332.134H788.857V148.577Z"
              fill="white"
            />
            <path
              id="web-sidebar"
              d="M685.948 178.279H613.272V302.434H685.948V178.279Z"
              fill="#F2F2F2"
            />
            <path
              id="web-header"
              d="M601.231 178.277H454.64V212.452H601.231V178.277Z"
              fill="#DAA520"
            />
            <path
              id="web-line1"
              d="M601.231 221.969H454.64V258.74H601.231V221.969Z"
              fill="#F2F2F2"
            />
            <path
              id="web-line2"
              d="M601.231 268.257H454.64V302.432H601.231V268.257Z"
              fill="#F2F2F2"
            />
          </g>
          <path
            id="arm-behind"
            d="M250.203 484.101C250.217 481.584 249.699 479.093 248.683 476.79C247.667 474.487 246.176 472.425 244.308 470.739C242.439 469.052 240.236 467.78 237.841 467.004C235.447 466.229 232.916 465.968 230.413 466.239C229.622 466.329 228.837 466.473 228.065 466.672L167.601 414.844L171.214 395.369L141.413 385.711L132.427 416.921C131.364 420.667 131.538 424.656 132.921 428.296C134.305 431.935 136.825 435.032 140.107 437.126L214.489 484.17C214.489 484.756 214.52 485.34 214.58 485.922C214.852 488.425 215.649 490.842 216.92 493.014C218.191 495.187 219.906 497.067 221.954 498.531C224.002 499.994 226.336 501.009 228.804 501.507C231.271 502.006 233.816 501.977 236.271 501.424C236.985 501.266 237.688 501.063 238.376 500.816C241.819 499.572 244.798 497.303 246.912 494.314C249.026 491.326 250.175 487.762 250.203 484.101V484.101Z"
            fill="#CA9B62"
          />
          <g id="chair">
            <path
              id="Vector_3"
              d="M99.8818 544.209H177.84C177.84 546.45 258.185 548.269 258.185 548.269C259.446 549.218 260.596 550.308 261.611 551.516C264.663 555.156 266.331 559.757 266.321 564.507V567.754C266.319 573.137 264.18 578.298 260.374 582.104C256.568 585.911 251.406 588.05 246.023 588.052H99.8818C94.5 588.047 89.34 585.907 85.5345 582.101C81.729 578.296 79.5891 573.136 79.5844 567.754V564.507C79.5918 559.126 81.7327 553.967 85.5376 550.162C89.3425 546.357 94.5009 544.217 99.8818 544.209V544.209Z"
              fill="#CF7000"
            />
            <path
              id="Vector_4"
              d="M184.682 587.245H163.573V723.644H184.682V587.245Z"
              fill="#AC5F04"
            />
            <path
              id="Vector_5"
              d="M244.763 725.341C244.763 727.895 212.775 726.329 173.316 726.329C133.857 726.329 101.869 727.895 101.869 725.341C101.869 722.787 133.857 702.535 173.316 702.535C212.775 702.535 244.763 722.787 244.763 725.341Z"
              fill="#B47225"
            />
          </g>
          <g id="leg-behind">
            <path
              id="Vector_6"
              d="M225.707 706.916L245.613 706.914L255.084 655.282L225.703 655.284L225.707 706.916Z"
              fill="#C89961"
            />
            <path
              id="shoe-behind"
              d="M220.629 726.212L284.819 726.21V725.398C284.819 722.117 284.173 718.868 282.917 715.837C281.661 712.806 279.821 710.052 277.501 707.732C275.181 705.412 272.427 703.571 269.396 702.316C266.365 701.06 263.116 700.414 259.835 700.414H259.833L220.628 700.416L220.629 726.212Z"
              fill="#2A2940"
            />
            <path
              id="Vector_7"
              d="M255.481 674.898L295.168 585.901C298.482 578.4 298.848 569.926 296.194 562.167C293.541 554.408 288.062 547.934 280.849 544.033L194.766 497.872L155.484 494.531L119.25 491.237L118.988 491.68C118.654 492.244 110.863 505.701 116.13 520.456C120.124 531.648 130.515 540.391 147.012 546.44C185.52 560.56 230.003 572.627 247.341 577.159C248.107 577.355 248.823 577.711 249.442 578.204C250.061 578.696 250.568 579.314 250.931 580.017C251.295 580.711 251.511 581.474 251.566 582.256C251.621 583.038 251.513 583.823 251.25 584.561L214.379 667.399C213.994 668.449 213.856 669.574 213.974 670.687C214.092 671.8 214.465 672.87 215.063 673.816C215.66 674.762 216.467 675.558 217.421 676.143C218.375 676.728 219.451 677.086 220.565 677.189L248.115 679.195C248.349 679.217 248.582 679.228 248.814 679.228C250.225 679.228 251.605 678.819 252.788 678.05C253.972 677.281 254.907 676.187 255.481 674.898V674.898Z"
              fill="#161515"
            />
          </g>
          <g id="leg-front">
            <path
              id="Vector_8"
              d="M212.716 706.916L232.622 706.914L242.094 655.282L212.713 655.284L212.716 706.916Z"
              fill="#CCA372"
            />
            <path
              id="shoe-front"
              d="M207.639 726.212L271.828 726.21V725.398C271.828 722.117 271.182 718.868 269.927 715.837C268.671 712.806 266.831 710.052 264.511 707.732C262.191 705.412 259.437 703.571 256.406 702.316C253.375 701.06 250.126 700.414 246.845 700.414H246.842L207.638 700.416L207.639 726.212Z"
              fill="#363548"
            />
            <path
              id="Vector_9"
              d="M240.867 679.769L280.554 590.773C283.868 583.272 284.234 574.798 281.58 567.039C278.927 559.28 273.447 552.805 266.234 548.904L180.151 502.744L140.87 499.402L112.489 496.941L112.493 496.551C112.159 497.116 104.368 510.572 109.634 525.328C113.629 536.52 115.9 545.262 132.398 551.312C170.905 565.431 215.389 577.499 232.727 582.031C233.493 582.226 234.209 582.582 234.828 583.075C235.447 583.567 235.954 584.185 236.317 584.888C236.681 585.583 236.897 586.345 236.952 587.127C237.007 587.909 236.899 588.694 236.636 589.433L199.765 672.27C199.38 673.321 199.241 674.446 199.36 675.558C199.478 676.671 199.851 677.742 200.448 678.688C201.046 679.634 201.853 680.43 202.807 681.014C203.761 681.599 204.837 681.957 205.951 682.06L233.501 684.066C233.735 684.089 233.968 684.1 234.199 684.1C235.61 684.099 236.991 683.69 238.174 682.921C239.358 682.153 240.293 681.058 240.867 679.769Z"
              fill="url(#paint2_radial_1_2)"
            />
          </g>
          <path
            id="man-body"
            d="M166.075 498.564C167.977 497.218 195.303 511.555 200.174 500.188C177.441 443.355 193.107 418.814 179.181 386.223C176.729 380.602 173.034 375.61 168.375 371.622C163.715 367.634 158.213 364.754 152.28 363.198L116.152 361.374L115.964 361.465C107.812 365.458 101.163 371.972 97.004 380.042C92.845 388.111 91.3971 397.306 92.8752 406.263C93.0037 441.732 114.226 468.783 106.805 494.51C106.494 495.585 106.403 496.713 106.538 497.824C106.673 498.935 107.031 500.008 107.591 500.978C108.133 501.915 108.862 502.731 109.732 503.376C110.603 504.021 111.596 504.481 112.65 504.727L160.355 498.364C161.469 498.629 162.627 498.654 163.752 498.436C164.877 498.218 165.942 497.763 166.877 497.102L166.075 498.564Z"
            fill="url(#paint3_linear_1_2)"
          />
          <g id="man-head">
            <path
              id="Vector_10"
              d="M128.209 347.88C150.235 347.88 168.091 330.024 168.091 307.998C168.091 285.972 150.235 268.116 128.209 268.116C106.183 268.116 88.3267 285.972 88.3267 307.998C88.3267 330.024 106.183 347.88 128.209 347.88Z"
              fill="#CCA372"
            />
            <path
              id="Vector_11"
              d="M87 361.5C89.1215 362.544 112.5 360 112.5 345.5C108 334 109.73 327.582 107.809 323.842C105.887 320.102 105.321 308.791 107.809 305.5C110.297 302.209 116.054 302.646 117.19 306.772C116.459 298.934 123.491 298.826 130.32 297.055C137.15 295.285 144.354 296.384 151.221 294.809C159.191 292.98 166.588 287.803 163.408 277.949C162.862 276.309 162.045 274.799 161 273.5C157.326 268.856 153.083 264.539 148.058 262.621C137.605 258.632 126.865 254.593 115.833 255.033C97.7069 255.757 80.5728 269.845 74.4657 289.047C73.7054 291.443 73.1164 293.904 72.7044 296.405C68.9178 319.297 58 329 78 345.5L87 361.5Z"
              fill="#5E4130"
            />
          </g>
          <g id="laptop">
            <path
              id="Vector_12"
              d="M324.654 408.738L329.228 435.894C329.279 436.197 329.245 436.508 329.131 436.793L293.251 526.447C293.109 526.802 292.849 527.097 292.516 527.284C292.182 527.471 291.794 527.538 291.417 527.473C291.04 527.409 290.697 527.217 290.444 526.93C290.191 526.643 290.045 526.278 290.029 525.896L288.509 489.868C288.499 489.629 288.54 489.391 288.63 489.169L321.457 408.387C321.594 408.05 321.837 407.766 322.15 407.58C322.462 407.394 322.827 407.315 323.189 407.354C323.55 407.394 323.889 407.551 324.154 407.801C324.418 408.05 324.594 408.38 324.654 408.738V408.738Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_13"
              d="M322.114 410.823L326.46 434.153L294.619 515.964L290.485 489.647L322.114 410.823Z"
              fill="#C7C4FF"
            />
            <path
              id="Vector_14"
              d="M182.804 526.029C183.588 529.088 286.444 532.398 287.511 531.473C288.468 530.288 289.297 529.005 289.985 527.645C291.063 525.72 292.061 523.789 292.061 523.789L290.37 491.26L189.049 480.432C189.049 480.432 184.567 507.578 183.159 520.049C182.841 522.026 182.722 524.029 182.804 526.029Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_15"
              opacity="0.1"
              d="M277.114 494.702L277.123 522.727L232.309 519.541L234.292 491.657L277.114 494.702Z"
              fill="black"
            />
            <path
              id="Vector_16"
              opacity="0.1"
              d="M218.717 499.557L218.988 499.523L216.872 511.437L191.975 509.667L192.825 497.716L218.717 499.557Z"
              fill="black"
            />
            <path
              id="Vector_17"
              opacity="0.1"
              d="M182.804 526.029C183.588 529.088 286.444 532.398 287.511 531.473C288.468 530.288 289.297 529.005 289.985 527.645L183.159 520.049C182.841 522.026 182.722 524.029 182.804 526.029Z"
              fill="black"
            />
          </g>
          <g id="arm-with-shoulder">
            <path
              id="arm-front"
              d="M141.503 477.453L228.267 493.645C228.484 494.188 228.729 494.72 229.001 495.238C230.18 497.456 231.812 499.402 233.792 500.947C235.772 502.493 238.055 503.605 240.492 504.211C242.94 504.827 245.49 504.912 247.974 504.462C250.457 504.013 252.815 503.037 254.891 501.602C258.651 499.021 261.282 495.099 262.243 490.64C263.204 486.182 262.424 481.524 260.061 477.623C257.699 473.721 253.933 470.871 249.537 469.656C245.141 468.442 240.446 468.955 236.416 471.091C235.714 471.467 235.039 471.892 234.396 472.363L159.035 446.619L155.178 427.19L123.918 429.258L127.157 461.828C127.551 465.628 129.158 469.201 131.743 472.016C134.327 474.831 137.75 476.738 141.503 477.453V477.453Z"
              fill="#CCA372"
            />
            <path
              id="arm-front-shoulder"
              d="M122.86 443.785L168.282 428.856L157.686 398.433C156.279 394.394 153.49 390.981 149.81 388.799C146.131 386.617 141.798 385.806 137.579 386.51V386.51C133.31 387.221 129.437 389.435 126.658 392.753C123.88 396.07 122.379 400.271 122.426 404.598L122.86 443.785Z"
              fill="url(#paint4_linear_1_2)"
            />
          </g>
          <path
            id="Vector_20"
            d="M411 727.804H30C29.7348 727.804 29.4804 727.698 29.2929 727.511C29.1054 727.323 29 727.069 29 726.804C29 726.538 29.1054 726.284 29.2929 726.096C29.4804 725.909 29.7348 725.804 30 725.804H411C411.265 725.804 411.52 725.909 411.707 726.096C411.895 726.284 412 726.538 412 726.804C412 727.069 411.895 727.323 411.707 727.511C411.52 727.698 411.265 727.804 411 727.804Z"
            fill="#CBCBCB"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_1_2"
            x1="158"
            y1="565"
            x2="523.5"
            y2="615"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E9CCCC" stopOpacity="0.52" />
            <stop offset="1" stopColor="#E4CFCF" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1_2"
            x1="516.147"
            y1="0.333344"
            x2="516.147"
            y2="713.613"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F8F1E2" stopOpacity="0.28" />
            <stop offset="1" stopColor="#F8F1E2" stopOpacity="0.984375" />
          </linearGradient>
          <radialGradient
            id="paint2_radial_1_2"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(263 560.5) rotate(179.148) scale(134.515 125.89)"
          >
            <stop stopColor="#1C1B1B" />
            <stop offset="1" stopColor="#161515" />
          </radialGradient>
          <linearGradient
            id="paint3_linear_1_2"
            x1="146.243"
            y1="361.374"
            x2="146.243"
            y2="504.727"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#46455C" />
            <stop offset="1" stopColor="#2F2E41" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_1_2"
            x1="145.354"
            y1="386.263"
            x2="145.354"
            y2="443.785"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3F3E54" />
            <stop offset="1" stopColor="#302F44" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}

export default SvgAnimation;
